import { render, staticRenderFns } from "./businessPlan.vue?vue&type=template&id=cf2ed5b8&"
import script from "./businessPlan.vue?vue&type=script&lang=js&"
export * from "./businessPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports